import styled from 'styled-components'
import { SubHeader as BaseSubHeader } from '../../../Styles'

export const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
`

export const SubHeader = styled(BaseSubHeader)`
    margin-bottom: 0;
`

export const StatusContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`

export const StatusLabel = styled.span`
    font-weight: bold;
    display: inline-block;
    margin-right: 8px;
    text-transform: capitalize;
`

export const CaseStatusLabel = styled.span`
    font-weight: bold;
    display: inline-block;
    margin-right: 8px;
`

export const CevFeedbackWrapper = styled.div`
    background: rgba(123, 173, 126, 0.15);
    padding: 12px;
    border-radius: 4px;
    margin-top: 8px;
    margin-bottom: 8px;
`

export const CevFeedbackLabel = styled.div`
    color: black;
    font-weight: bold;
`
